import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {InfocardComponent} from 'src/app/infocard/infocard.component';
// import {MatCarouselModule} from '@thouet/material-carousel';
import {NewsService} from 'src/app/modules/news/news.service';
import {Component, computed, inject} from '@angular/core';
import {Infocard} from 'src/app/modules/news/infocard';

@Component({
    templateUrl: './startseite-page.component.html',
    styleUrls: ['./startseite-page.component.scss'],
    imports: [InfocardComponent, MatProgressSpinnerModule],
})
export class StartseitePageComponent {
    private newService = inject(NewsService);
    slides = [
        {image: '/assets/img/startseite/KKM-Slideshow-1.jpg'},
        {image: '/assets/img/startseite/KKM-Slideshow-2.jpg'},
        {image: '/assets/img/startseite/KKM-Slideshow-3.jpg'},
        {image: '/assets/img/startseite/KKM-Slideshow-4.jpg'},
    ];
    sportbereiche: Infocard[] = [
        {
            image: '/assets/img/startseite/wander_1.jpg',
            titel: 'Termine',
            text: 'Hier findet Ihr die Termine die dieses Jahr noch anstehen.',
            mehr: '/verein/kalender',
        },
        {
            image: '/assets/img/startseite/sommer_1.jpg',
            titel: 'Sommertraining',
            text: 'In der Saison von Ende März bis Ende Oktober treffen wir uns Dienstags ab 17:30 Uhr am Bootshaus. Von dort wird gemeinsam oder in kleineren Gruppen gestartet. Gepaddelt wird auf dem Main, je nach Lust und Laune in Wanderbooten, Seekajaks und Kanadiern. Auch Wildwasser- und Poloboote stehen zur Verfügung. Sehr beliebt ist auch das Paddeln im Stehen auf den SUP-Boards.',
            mehr: '/training/sommertraining',
        },
        {
            image: '/assets/img/startseite/polo_1.jpg',
            titel: 'Wintertraining',
            text: 'In der Wintersaison zwischen November und Ende März paddeln nur einige Unentwegte. Die sportlichen Aktivitäten verlagern sich nach drinnen. Mittwochs besteht die Möglichkeit zum Kraftausdauertraining in der Turnhalle des FEG Mühlheim...',
            mehr: '/training/wintertraining',
        },
    ];
    isLoading = computed(() => this.newService.isLoading());
    news = computed(() => {
        return this.newService
            .newsListe()
            .slice(0, Math.min(4, this.newService.newsListe().length))
            .map(element => ({
                image: '',
                titel: element.betreff || '',
                text: element.beschreibung || '',
                mehr: '/news',
                datum: element.datum,
            }));
    });
}
